/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CancelAction from './CancelAction/index'
import DisconnectAction from './DisconnectAction/index'
import React from 'react'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Disconnect/Content"
  
}) {
let dtColorsOrange700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.700'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClose = fromHelpers.useOnClose({
  children,
  viewPath
  
})
let constantData = 'Are you sure you want to disconnect the '
let connectionMetadataTitleValueData = fromData.useDataValue({ viewPath,
context: 'connection',
path: 'metadata.title',
})
let constantData1 = ' connection from '
let globalCurrentLocationParentCompanyNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.name',
})
let constantData2 = '?'
let aggregateData = fromAggregate.joinNoSpace(constantData, connectionMetadataTitleValueData, constantData1, globalCurrentLocationParentCompanyNameValueData, constantData2)
let constantData3 = 'All locations in '
let globalCurrentLocationParentCompanyNameValueData1 = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.name',
})
let constantData4 = ' will be disconnected from this connection. Disconnecting will also disable all automations under this app.'
let aggregateData1 = fromAggregate.joinNoSpace(constantData3, globalCurrentLocationParentCompanyNameValueData1, constantData4)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconWarning
  viewPath={`${viewPath}/TysiaIconWarning`}
 height={20}
 width={20}
 fill={dtColorsOrange700}
/>
<TysiaModalHeaderTitle
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 marginLeft={dtSpaceXs}
 text="Disconnect connection"
/>
</div>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 onClose={onClose}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="'Are you sure you want to disconnect the '"
 data="connection.metadata.title"
 data="' connection from '"
 data="global.current_location.parent_company.name"
 data="'?'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 data="'All locations in '"
 data="global.current_location.parent_company.name"
 data="' will be disconnected from this connection. Disconnecting will also disable all automations under this app.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData1}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<DisconnectAction
{...childProps}
  viewPath={`${viewPath}/DisconnectAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}